import React, { ReactNode, useState } from 'react';
import { LayoutChangeEvent, Platform, View } from 'react-native';

interface ModalViewportProps {
  children: ReactNode;
}

const ModalViewport = ({ children }: ModalViewportProps) => {
  // Android's dialog receives its window bounds separately from mounting the React tree.
  const [hasLayout, setHasLayout] = useState(Platform.OS !== 'android');

  const handleLayout = (event: LayoutChangeEvent) => {
    const { width, height } = event.nativeEvent.layout;
    if (width > 0 && height > 0) {
      setHasLayout(true);
    }
  };

  return (
    <View style={{ flex: 1 }} collapsable={false} onLayout={handleLayout}>
      {hasLayout && children}
    </View>
  );
};

export default ModalViewport;
